import { themes } from '@helpers/brand';
import { cssVar } from '@helpers/cssVar';
import styled from 'styled-components';
const Link = styled.a `
  ${themes['dark']};

  position: fixed;
  top: 0;
  left: 50%;
  display: block;
  background: ${cssVar('bgColor')};
  color: ${cssVar('fgColor')};
  height: 30px;
  padding: 8px;
  transform: translateX(-50%) translateY(-100%);
  transition: transform 0.15s ease-out;
  z-index: 2000;

  &:focus {
    transform: translateX(-50%) translateY(0%);
  }
`;
export default {
    Link,
};
